import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../../components/LoadingPage';
import { deleteSchoolMission, fetchSchoolMissions, insertNewSchoolMission, updateSchoolMissionById } from '../../../services2/schoolMissions.service';
import { fetchMissions } from '../../../services2/missions.service';
import RemoveSvg from '../../../svg/admin/Remove';
import AddSvg from '../../../svg/admin/Add';
import { fetchQuestionnaires } from '../../../services2/questionnaires.service';
import DropDown from '../../components/DropDownMenu';
function Component(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    const [missions, setMissions] = useState([])
    const [schoolMissions, setschoolMissions] = useState([])
    const [isLoading, setisLoading] = useState(false)
    const [questionnaires, setQuestionnaires] = useState([])

    const fetchQuestionnaireList = async () => {
        let result = await fetchQuestionnaires(props.token.token, {}, { limit: 999, skip: 0 }, { name:1});
        if (result.result) {
            setQuestionnaires(result.result)
        } else {
            console.log('Fetch data error')
        }
    }

    const fetchSchoolLists = async () => {
        let result = await fetchSchoolMissions(props.token.token, { schoolId: id }, { limit: 999, skip: 0 });
        if (result.result) {
            setschoolMissions(result.result)
        } else {
            alert('Fetch data error')
        }
    }
    const fetchMissions_ = async () => {
        let result = await fetchMissions(props.token.token, { status: '啟動中' }, { limit: 999, skip: 0 });
        if (result.result) {
            setMissions(result.result)
        } else {
            alert('Fetch data error')
        }
    }
    const refresh = () => {
        setisLoading(true)
        fetchSchoolLists()
        fetchMissions_()
        setisLoading(false)
    }
    useEffect(() => {
        refresh()
    }, [id])

    useEffect(() => {
        fetchQuestionnaireList()
    }, [])

    const handleAddMission = (mission) => async ()=>{
        if(schoolMissions.filter(i=>(i?.mission?._id===mission?._id))?.length>0)return
        setisLoading(true)
        let result = await insertNewSchoolMission(props.token.token, id,mission?._id );
        if (result.result) {
            refresh()
        } else {
            alert('更新錯誤:' + JSON.stringify(result?.message))
        }
        setisLoading(false)
    }
    const handleRemove=(item)=>async ()=>{  
        setisLoading(true)
        let result = await deleteSchoolMission(props.token.token, item?._id);
        if (result.result) {
            refresh()
        } else {
            alert('更新錯誤:' + JSON.stringify(result?.message))
        }
        setisLoading(false)
    }



    return (
        <div className='fixed top-0 left-0 w-full h-full bg-[#00000090] flex flex-col justify-center items-center'>
            <div className='flex flex-col gap-[8px] bg-[white] p-[16px] rounded-[7px] max-w-[600px] w-full'>
                <div className='font-[700] text-[24px]'>編輯閲讀任務</div>

                <div className='w-full flex flex-row mt-[16px]' style={{borderBottom:'1px solid black'}}>
                    <div className='font-[700] flex-1'>已批准的任務</div>
                    <div className='font-[700] flex-1'>問卷調查</div>
                    <div className='w-[30px]'/>
                </div>
                {schoolMissions.map((item, index) => <div key={item?._id||index} className='w-full flex flex-row gap-[8px] items-center'>
                        <div className='flex-1'>{item?.mission?.name}</div>
                        <div className='flex-1'>
                            <DropDown options={questionnaires?.map(item=>item.name)} value={questionnaires.filter(i=>(i?._id===item?.questionnaire2Id))?.[0]?.name} 
                            select={async (option,optionIndex)=>{
                                let selectedQuestionnaire=questionnaires?.[optionIndex]
                                setisLoading(true)
                                let result = await updateSchoolMissionById(props.token.token, item?._id,{questionnaire2Id:selectedQuestionnaire?._id} );
                                if (result.result) {
                                    fetchSchoolLists()
                                } else {
                                    alert('更新錯誤:' + JSON.stringify(result?.message))
                                }
                                setisLoading(false)
                            }}/>
                        </div>
                        <div onClick={handleRemove(item)} className='w-[30px] cursor-pointer'>
                            <RemoveSvg/>
                        </div>
                    </div>
                )}
                {schoolMissions?.length === 0 && <div className='text-[#898989]'>無任務</div>}

                <div className='font-[700] mt-[32px]' style={{borderBottom:'1px solid black'}}>可添加的任務 </div>
                {missions.map((item, index) => <div key={item?._id||index} className='w-full flex flex-row gap-[8px]' style={{opacity: schoolMissions.filter(i=>(i?.mission?._id===item?._id))?.length>0?0.3:1}}>
                        <div className='flex-1'>{item?.name}</div>
                        <div onClick={handleAddMission(item)} className='w-[30px] bg-[grey] cursor-pointer rounded-[12px] flex justify-center items-center'>
                            <AddSvg/>
                        </div>
                    </div>
                )}
                <div className='flex flex-row w-full justify-center mt-[64px]'>
                    <div onClick={props.back} className='text-[#1F4CC8] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{ border: '1px solid #1F4CC8' }}>
                        返回
                    </div>
                </div>
            </div>



            {isLoading && <LoadingPage />}
        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
